import { FC, useEffect, useState } from "react";
import ObjectTabsLayout from "components/common/objects/ObjectTabsLayout/ObjectTabsLayout";

// Data
import { useAppSelector } from "hooks";
import {
  selectDrawerSelectedAccountId,
  selectSpecificObjectState
} from "app/data/selectors";
import { isMonitoringTabEnabled } from "app/data/helpers";
import { useNavigate, useParams } from "react-router-dom";
import ObjectMonitoringSection from "components/sections/objects/ObjectMonitoringSection/ObjectMonitoringSection";

const ObjectMonitoring: FC = () => {
  const navigate = useNavigate();
  const params = useParams();

  // Global State
  const drawerSelectedAccountId =
    useAppSelector(selectDrawerSelectedAccountId) || "";
  const { specificObject } = useAppSelector(selectSpecificObjectState);
  const [selectAccountId, setSelectedAccountId] = useState(
    drawerSelectedAccountId
  );

  useEffect(() => {
    if (!isMonitoringTabEnabled(drawerSelectedAccountId)) {
      const objectId = specificObject?.uniqueId || params.id;
      navigate(
        objectId
          ? `/dashboard/objects/details/${objectId}`
          : "/dashboard/objects",
        { replace: true }
      );
      return;
    }

    if (drawerSelectedAccountId !== selectAccountId) {
      setSelectedAccountId(drawerSelectedAccountId);
      navigate("/dashboard/objects");
    }
  }, [
    drawerSelectedAccountId,
    navigate,
    params.id,
    selectAccountId,
    specificObject?.uniqueId
  ]);

  return (
    <main>
      <ObjectTabsLayout>
        <ObjectMonitoringSection specificObject={specificObject} />
      </ObjectTabsLayout>
    </main>
  );
};

export default ObjectMonitoring;
